<template>
  <component :is="productData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="productData === undefined">
      <h4 class="alert-heading">Error fetching product data</h4>
      <div class="alert-body">
        No product found with this product id. Check
        <b-link class="alert-link" :to="{ name: 'product-list' }">
          Product List
        </b-link>
        for other products.
      </div>
    </b-alert>
  
    <add-new-product-from-url
      v-if="productData"
      :url.sync="url"
      :product-data="productData"
      :is_data_fetch="is_data_fetch"
      @refetch-data="productFetchData"
      @reset-data="resetProductData"
      :loading="loading"
      @update-loading-state="updateLoadingState"
      class="mt-2 pt-75"
    />
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref, onUnmounted, watch, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import toolsStoreModule from "./toolsStoreModule";
import AddNewProductFromUrl from "./AddNewProductFromUrl.vue";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    AddNewProductFromUrl,
  },
  setup() {
    const productData = ref(null);
    const loading = ref(false);

    const APP_PRODUCT_STORE_MODULE_NAME = "app-tool";


    const resetProductData = () => {
      console.log('resetProductData')
      productData.value = {
        id: 0,
        model: "",
        sku: "",
        mpn: "",
        price: 0,
        name: "",
        description: "",
        short_description: "",
        meta_title: "",
        meta_description: "",
        meta_keyword: "",
      };
    };

    // Register module
    if (!store.hasModule(APP_PRODUCT_STORE_MODULE_NAME))
      store.registerModule(APP_PRODUCT_STORE_MODULE_NAME, toolsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_PRODUCT_STORE_MODULE_NAME))
        store.unregisterModule(APP_PRODUCT_STORE_MODULE_NAME);
    });
    const url = ref(null);

    const is_data_fetch = ref(false);

    const productFetchData = () => {
      console.log('start productFetchData')
      resetProductData()
      if (url.value) {
            console.log('productFetchData in url')
        loading.value = true;
        is_data_fetch.value = true;
        store
          .dispatch("app-tool/fetchHKTVData", {
            url: url.value,
          })
          .then((response) => {
            loading.value = false;

            console.log('productFetchData fetch finish')
            url.value = null;
            productData.value = response.data;
            productData.value.id = 0
          })
          .catch((error) => {
            productData.value = {};
          })
          .finally(() => (loading.value = false));
      }
    };


    watch(url, (newVal) => {
      if(newVal){
        productFetchData();
      }
    });

    const refetchData = () => {
      console.log('refetchData')
      productFetchData();

    };



    onMounted(() => {
      refetchData();
    });

    const updateLoadingState = (value) => {
      loading.value = value;
    };

    return {
      productData,
      productFetchData,
      refetchData,
      loading,
      url,
      updateLoadingState,
      is_data_fetch,
      resetProductData,
    };
  },
};
</script>

<style lang="scss"></style>
